import { useContext } from "react"
import { POCreditMemoContext } from "../context/POCreditMemoContext";
import CreditMemoNewProducts from "./CreditMemoNewProducts";
import CreditMemoProducts from "./CreditMemoProducts";

export default function CreditMemoDetailsPanel() {

	const { creditMemo } = useContext(POCreditMemoContext);

	return (
		<div className='dx-card wide-card'>
			<div className='grid-header'>Credit Memo Details</div>
			{
				!creditMemo.details.creditMemoID ?
					<CreditMemoNewProducts /> :
					<CreditMemoProducts />
			}
		</div>
	)
}